import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import "swiper/css";
import "swiper/css/effect-cards";
import CartTicket from "../CartTicket";
import "./styles.scss";
import useScreen, { SCREEN_LIST } from "../../hook/useScreen";
import { useTheme } from "../../hook/useThemes";
import { activeEventFathom } from "../../utils/utils";
interface IPropsListCartTicket {
  dataList: any[];
  onChangeIndex?: (index: number) => void;
}

const ListCartTicketMobile = ({
  dataList: items,
  onChangeIndex,
}: IPropsListCartTicket) => {
  const heightScreen = useScreen();
  const isMinHeight = heightScreen < SCREEN_LIST.screenHeight3;
  const { settingCard } = useTheme();
  const { tracker = "vertical" } = settingCard;
  const refSwiper = useRef<any>();

  const itemLive = items?.[0] || undefined;

  useEffect(() => {
    if (itemLive && refSwiper.current) {
      if (!!itemLive?.position) {
        try {
          refSwiper.current.swiper.slideTo(0);
        } catch (error) {
          console.log(error);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemLive?.id]);

  if (!items?.length) {
    return <></>;
  }

  return (
    <div className="wrapper-cart-ticket-mobile">
      <Swiper
        effect={"cards"}
        grabCursor={true}
        modules={[EffectCards]}
        className={`mobile-card-swiper ${
          isMinHeight && "mobile-card-swiper-min"
        }
        mobile-card-swiper-${tracker}
        `}
        onAfterInit={(swiper) => {
          swiper.slideNext();
        }}
        onSlideChange={(e) => {
          const activeIndex = e.activeIndex || 0;
          const previousIndex = e.previousIndex || 0;
          onChangeIndex?.(activeIndex);

          if (activeIndex > previousIndex) {
          activeEventFathom("MobileSwipe-Right");
            return;
          }
          activeEventFathom("MobileSwipe-Left");
        }}
        ref={refSwiper}
      >
        {items.map((item, index: number) => {
          return (
            <SwiperSlide key={item?.id}>
              <CartTicket zIndex={index} contest={item} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ListCartTicketMobile;
